import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const adminNewsApi = createApi({
  reducerPath: "adminNews",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getNews: builder.query({
      query: ({ page: { startRow, endRow } }) => ({
        url: "/admin/news/list",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { startRow, endRow },
      }),
    }),
    getNewsDetail: builder.query({
      query: (id) => ({
        url: "/admin/news/" + id,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
  }),
});

export const { useGetNewsQuery, useGetNewsDetailQuery } = adminNewsApi;
